// react-native-webview renders "does not support this platform" on web (RNW has
// no WebView). Shim it to a real <iframe> so WebView screens render. Supports
// source={{uri}} and source={{html}}; maps onLoadEnd/onLoad. Aliased via
// react-native-webview$. Absolute https URLs that send X-Frame-Options are
// routed through the devserver /frame proxy (same-origin, framing headers stripped).
const React = require("react");
const View = require("react-native-web/dist/exports/View").default;

function WebView(props) {
  const {
    source = {},
    style,
    onLoad,
    onLoadEnd,
    onError, // eslint-disable-line no-unused-vars
    injectedJavaScript, onMessage, onLoadStart, onNavigationStateChange,
    startInLoadingState, scalesPageToFit, javaScriptEnabled, domStorageEnabled,
    originWhitelist, ...rest // eslint-disable-line no-unused-vars
  } = props || {};
  const iframeProps = {
    title: "webview",
    style: { border: "0", width: "100%", height: "100%", flexGrow: 1 },
    onLoad: onLoadEnd || onLoad,
  };
  if (source && source.uri) {
    iframeProps.src = /^https?:\/\//.test(source.uri)
      ? "/frame?url=" + encodeURIComponent(source.uri)
      : source.uri;
  } else if (source && source.html) iframeProps.srcDoc = source.html;
  return React.createElement(
    View,
    { style: [{ flex: 1 }, style] },
    React.createElement("iframe", iframeProps),
  );
}

module.exports = { __esModule: true, WebView, default: WebView };
